import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { TimeRange } from '@mi-front/core';
import { STREAM_RETENTION_DAYS_DEFAULT } from '../../consts';
import { calculateAllowedRange } from './calculate-allowed-range';

/**
 * Returns the allowed [from, to] range for the current station's stream time navigation.
 * - from: earliest allowed start of a stream range (start of day at now - retentionDays).
 * - to: upper bound — latest time that can be used as the start (from) of a stream range (now - 20 min).
 * Uses station.retentionDays; falls back to STREAM_RETENTION_DAYS_DEFAULT when not set.
 * Use in time-move controls to validate that:
 * - Move backwards does not navigate before range.from.
 * - Move forwards does not navigate past range.to.
 */
export function useStationStreamableRange(): TimeRange<number> {
  const station = useActiveStation();
  const now = Date.now();
  const retentionDays = station.retentionDays ?? STREAM_RETENTION_DAYS_DEFAULT;

  return calculateAllowedRange(now, {
    retentionDays,
    lookbackMs: 0,
  });
}
